import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { dynamicPluralization } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import {
    getFilterData,
    setMoreClick,
    getAdminUserList,
    setClearFilter,
    setAdminFilterOpen,
    setSelectedSalesOrg,
    setSelectedViews,
    clearAdminFilters,
} from 'src/pages/admin/redux/action';
import {
    ClearFilterDesktop,
    FilterContainer,
    FilterDetailsContainer,
    ExtraContainer,
    FilterStringWithPipe,
    ClearFilterMobile,
    FilterOptionSelect,
    ViewContainer,
} from 'src/pages/admin/filter/filterResult/index.styled.jsx';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const ViewFilters = (props) => {
    {
        /*Pass in the appliedViews or appliedFilters as an array of selected filters from respective stores of parent component   */
    }
    const { appliedFilters = [] } = props; 

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );
    const saleOrgView = useSelector(
        (state) => state.AdminReducer.adminUser?.salesOrgFilter
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

    const [, setViewOverflow] = useState(false);
    const [filterOverflow, setFilterOverflow] = useState(false);
    const filterRef = useRef('');
    const viewRef = useRef('');

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        if (viewRef.current && viewRef.current.scrollWidth) {
            setViewOverflow(
                !(viewRef.current.scrollWidth <= viewRef.current.clientWidth)
            );
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        if (filterRef.current && filterRef.current.scrollWidth) {
            setFilterOverflow(
                !(
                    filterRef.current.scrollWidth <=
                    filterRef.current.clientWidth
                )
            );
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    useEffectWithErrorLogging(() => {
        if (viewRef.current && viewRef.current.scrollWidth) {
            setViewOverflow(
                !(viewRef.current.scrollWidth <= viewRef.current.clientWidth)
            );
        }
        if (filterRef.current && filterRef.current.scrollWidth) {
            setFilterOverflow(
                !(
                    filterRef.current.scrollWidth <=
                    filterRef.current.clientWidth
                )
            );
        }
    }, [dimensions]);
    const onMoreButtonClick = () => {
        dispatch(setMoreClick(true));
        dispatch(getFilterData(true));
        dispatch(setAdminFilterOpen(true));
    };
    const handleClearClick = () => {
        sessionStorage.removeItem('items');
        sessionStorage.removeItem('SalesOrgView');
        if (!isImpersonationActive) {
            sessionStorage.removeItem('selectedViews');
            sessionStorage.removeItem('param');
            sessionStorage.removeItem('appliedData');
        } 
        props.setClearFilterClicked(true);
        dispatch(setClearFilter(true));
        dispatch(getFilterData(false));

        dispatch(getAdminUserList());
        props.resetHandler();
        let salesOrgData = saleOrgView &&
            saleOrgView.length > 0 && [...saleOrgView];
        salesOrgData &&
            salesOrgData.length > 0 &&
            salesOrgData.map((item) => {
                if (item.isDefault) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            });
        dispatch(
            setSelectedViews({
                salesOrgView: salesOrgData,
                districtView: { id: 'All District', name: 'All' },
                territoryView: { id: 'All Territory', name: 'All' },
                roleView: { id: 'All', name: 'All' },
            })
        );
        dispatch(setSelectedSalesOrg(salesOrgData));

        dispatch(clearAdminFilters(true));
    };

    // let viewString = '';
    // Array.isArray(appliedViews) &&
    //     appliedViews.map((filter, index) => {
    //         if (index < appliedViews.length - 1) {
    //             viewString += `${filter} | `;
    //         } else {
    //             viewString += `${filter} `;
    //         }
    //     });

    let filterString = '';
    let viewString = '';

    Array.isArray(appliedFilters) &&
        appliedFilters.map((filter, index) => {
            if (Array.isArray(filter)) { 
            } else {
                if (index < appliedFilters.length - 1) {
                    filterString += `${filter} | `;
                } else {
                    filterString += `${filter} `;
                }
            }
        });
    props.filtersList &&
        props.filtersList &&
        props.filtersList.length > 0 &&
        Array.isArray(props.filtersList) &&
        // !adminFilterOpen ?
        props.filtersList
            .filter(
                (itemData) =>
                    (itemData.isChecked ||
                        (!Object.prototype.hasOwnProperty.call(
                            itemData,
                            'isChecked'
                        ) &&
                            itemData.isDefault)) &&
                    itemData.value !== 'All'
            )
            .map((item, filterIndex) => {
                if (
                    item.isChecked ||
                    (!Object.prototype.hasOwnProperty.call(item, 'isChecked') &&
                        item.isDefault)
                ) {
                    viewString += `${item.name} `;
                    viewString +=
                        props.filtersList.filter(
                            (itemData) =>
                                (itemData.isChecked ||
                                    (!Object.prototype.hasOwnProperty.call(
                                        itemData,
                                        'isChecked'
                                    ) &&
                                        itemData.isDefault)) &&
                                itemData.value !== 'All'
                        ).length > 1 &&
                        props.filtersList.filter(
                            (itemData) =>
                                (itemData.isChecked ||
                                    (!Object.prototype.hasOwnProperty.call(
                                        itemData,
                                        'isChecked'
                                    ) &&
                                        itemData.isDefault)) &&
                                itemData.value !== 'All'
                        ).length -
                            1 !=
                            filterIndex
                            ? '| '
                            : '';
                }
            });
    // :
    // selectedSalesOrg
    //     ?.filter((itemData) => itemData.isChecked)
    //     .map((item, filterIndex) => {
    //         if (item.isChecked) {
    //             viewString += `${item.name} `;
    //             viewString +=
    //                 props.filtersList.salesOrgFilter.filter(
    //                     (itemData) => itemData.isDefault
    //                 ).length > 1 &&
    //                 props.filtersList.salesOrgFilter.filter(
    //                     (itemData) => itemData.isDefault
    //                 ).length -
    //                     1 !=
    //                     filterIndex
    //                     ? `| `
    //                     : '';
    //         }
    //     });
    return (
        <>
            <FilterOptionSelect>
                {(viewString ||
                    (appliedFilters && appliedFilters.length > 0)) && (
                    <Grid item xs={12} sm={12} mobile={12}>
                        {/* <ClearFilterMobile id="admin-filterResult-clearFilter-mobile" onClick={handleClearClick}>
                            {t('accounts.accountFilterBox.clearFilters')}
                        </ClearFilterMobile> */}
                    </Grid>
                )}
                <Grid
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    alignContent="center"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs={12}
                        sm={10}
                        md={10}
                        lg={10}
                        xl={10}
                        mobile={12}
                    >
                        <FilterContainer
                            mobileBackgroundColor={'#f5f5f5'}
                            {...props}
                        >
                            {viewString ? (
                                <ViewContainer
                                    {...props}
                                    style={{
                                        margin: '0',
                                        wordBreak:
                                            isLanguageChanged && 'keep-all',
                                    }}
                                >
                                    {t('calendar.filterResultsPanel.viewLabel')}
                                    :{' '}
                                    <Grid
                                        item
                                        xs={9}
                                        sm={9}
                                        md={9}
                                        lg={12}
                                        xl={9}
                                        mobile={9}
                                    >
                                        <FilterStringWithPipe
                                            mbViewWidth
                                            ref={viewRef}
                                            {...props}
                                        >
                                            {viewString}
                                        </FilterStringWithPipe>
                                    </Grid>
                                </ViewContainer>
                            ) : (
                                ''
                            )}
                            {appliedFilters && appliedFilters.length > 0 ? (
                                <FilterDetailsContainer
                                    {...props}
                                    mobileWidth={props.mobileWidth}
                                    marginTop={'4px'}
                                    marginLeft={'10px'}
                                >
                                    <>
                                        <>
                                            {appliedFilters[0] !== '' &&
                                            appliedFilters.length > 0
                                                ? `${dynamicPluralization(
                                                      t(
                                                          'calendar.filterResultsPanel.filterLabel'
                                                      ),
                                                      t(
                                                          'calendar.filterResultsPanel.filtersLabel'
                                                      ),
                                                      appliedFilters.length
                                                  )}  (${
                                                      appliedFilters.length
                                                  }): `
                                                : null}
                                        </>
                                        <FilterStringWithPipe
                                            ref={filterRef}
                                            {...props}
                                        >
                                            {filterString}
                                        </FilterStringWithPipe>
                                    </>
                                    {filterOverflow && (
                                        <ExtraContainer
                                            id="admin-filterResult-moreButton"
                                            {...props}
                                            // eslint-disable-next-line no-unused-vars
                                            onClick={(e) => {
                                                onMoreButtonClick();
                                            }}
                                        >
                                            {t(
                                                'accounts.accountFilterBox.more'
                                            )}
                                        </ExtraContainer>
                                    )}
                                </FilterDetailsContainer>
                            ) : null}
                        </FilterContainer>
                    </Grid>
                    {(viewString ||
                        (appliedFilters && appliedFilters.length > 0)) && (
                        <Grid
                            item
                            xs={12}
                            sm={2}
                            md={2}
                            lg={2}
                            xl={2}
                            mobile={12}
                        >
                            <ClearFilterDesktop 
                             id="admin-filterResult-clearFilter-desktop"
                             onClick={handleClearClick}>
                                {t('accounts.accountFilterBox.clearFilters')}
                            </ClearFilterDesktop>
                        </Grid>
                    )}
                </Grid>
            </FilterOptionSelect>
        </>
    );
};

export default ViewFilters;
